import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {EditableTableRow} from "../Parts/EditableTableRow"

export default class Financial_Final_Numbers extends Framework.Components.Collection {
	//Pay Center Admin route pay_center_admin data entry
	constructor(props) {
		localStorage.removeItem('table-preferences-Financial_Final_Numbers');
		let model = new API.BuildClass(Types.Financials._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_ADMIN';
		this.state.limit = 16;
		this.state.sorted = [];
	}

	async componentDidMount() {
		super.componentDidMount();
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.filterDate = this.props.filter_date;
		await this.fetchData(this.state);
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (this.props.filterFEs === true) {
			//set parent filter var back to false
			if (typeof this.props.toggleFilter === 'function') {
				this.props.toggleFilter();
			}

			//set filter and recall fetchData
			this.state.filter.filterDate = this.props.filter_date;
			this.state.filter.filterFEs = true;
			await this.fetchData(this.state);
		}

		if (this.props.submit === true) {
			//do submit here
			let model = new API.BuildClass(Types.Financials._name, API.RequestType.UPDATE);
			model.object.financial_data = this.state.data;
			model.submit(null, 'POST').then();

			//set parent submit var back to false
			if (typeof this.props.toggleSubmit === 'function') {
				this.props.toggleSubmit();
			}
		}

		//if the filter date changes, then re-get the data
		if(this.props.filter_date !== prevProps.filter_date){
			if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
				this.state.filter = {};
			}
			this.state.filter.filterDate = this.props.filter_date;
			await this.fetchData(this.state);
		}
	}




	updateTextField = async (key, column, event) => {
		let newData = [...this.state.data]; // clone array
		let updatedRow = { ...newData[key] }; // clone row
		const newValue = event.currentTarget.value;

		if (column === "bonus") {
			updatedRow[column] = !updatedRow[column];
		} else if (column === "notes") {
			updatedRow[column] = newValue;
		} else {
			if (newValue === '' || /^-?\d*\.?\d*$/.test(newValue)) {
				updatedRow[column] = newValue;
			}
		}

		newData[key] = updatedRow;

		this.setState({ data: newData }); // triggers re-render

		//TODO: update the total_pay in here too based off the column when we start to autofill stuff
	};

	render() {
		const {loading} = this.state;

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
						</div>
					</div>

					<div className="row">

						<div className="col">
							<table className="table table-bordered table-striped">
								<thead>
									<tr className="thead-dark">
										<th className="text-center">Name</th>
										<th className="text-center">Base Pay</th>
										<th className="text-center">Commission</th>
										<th className="text-center">Travel Fee</th>
										<th className="text-center">Feedback</th>
										<th className="text-center">Bonus</th>
										<th className="text-center">Subtractions</th>
										<th className="text-center">Total Pay</th>
										<th className="text-center">Notes</th>
									</tr>
								</thead>
								<tbody>
									{this.state.data.map((row, i) => (
										<EditableTableRow
											key={row.pkey}
											row={row}
											rowIndex={i}
											onUpdate={this.updateTextField}
										/>
									))}
								</tbody>
							</table>
						</div>
					</div>


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
